import { styled } from '@mui/material/styles';
import { Container } from "@mui/material";

export const StyledContainer = styled(Container)(() => ({
  marginTop: 72,
  padding: '0px 24px',
}));
